import {StoreType} from '../../../types/sharedTypes';

export const allCarriersSelector = (state: StoreType) => {
  return state.carrierReducer.carriersResult;
}
